import { ChangeEvent } from 'react';
import { FormControlLabel, styled, Switch, SwitchProps, SxProps, Theme, lighten } from '@mui/material';
import { VigoTypography } from '../vigo-typography';

export interface ToggleProps {
  name: string;
  checked?: boolean;
  sx?: SxProps<Theme>;
  formControlSx?: SxProps<Theme>;
  required?: boolean;
  disabled?: boolean;
  label?: string;
  labelPlacement?: 'top' | 'bottom' | 'end' | 'start' | undefined;
  onChange?: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  labelSx?: SxProps<Theme>;
}

const ModeSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 36,
  height: 18,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(17px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: lighten(theme.palette.customColors.primaryGradient, 0.6),
        opacity: 1,
        border: 0
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        // opacity: 0.5
      },
      '& .MuiSwitch-thumb': {
        color: theme.palette.customColors.primaryGradient
      }
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff'
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      // color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      // opacity: theme.palette.mode === 'light' ? 0.7 : 0.3
    }
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 14,
    height: 14
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#626679' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500
    })
  }
}));

export const VigoToggle = ({
  name,
  checked,
  sx,
  formControlSx,
  required,
  disabled,
  label,
  labelPlacement,
  onChange,
  labelSx
}: ToggleProps) => {
  function handleChange(e: ChangeEvent<HTMLInputElement>, checked: boolean) {
    onChange?.(e, checked);
  }

  return (
    <FormControlLabel
      sx={{ ...formControlSx }}
      control={
        <ModeSwitch
          className="vigoToggle"
          name={name}
          checked={checked}
          sx={{
            ml: 1,
            mr: 1,
            ...sx
          }}
          required={required}
          disabled={disabled}
          onChange={handleChange}
          inputProps={{
            className: 'vigo-hintstep-' + name + ' '
          }}
        />
      }
      label={<VigoTypography value={label} sx={labelSx} />}
      labelPlacement={labelPlacement}
    />
  );
};
